import apiClient from '../apiClient';
import { GET_SERVICE_PRICE_URL } from '../apiUrl';

const getServicePrice = id => {
  return apiClient.get(GET_SERVICE_PRICE_URL(id));
};

export default getServicePrice;
